import angular from 'angular';
import eventsComponent from './events.component';
import EventsService from './events.service';
import eventsConfig from './events.config';

import FeaturedSliderModule from '../../home/featured-slider/featured-slider';

let eventsModule = angular.module('events',[])
  .component('events', eventsComponent)
  .service('eventsService', EventsService)
  .config(eventsConfig);

export default eventsModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/events.js
 **/